export default __webpack_public_path__ + "static/media/midterm3.9dfcbbbc.jpg";